<div (resized)="onResize($event)" class="toolbar w-full flex items-center">
	<ng-container *ngFor="let item of items">
		<ng-container *ngIf="!item.hide">
			<ng-template
				*ngTemplateOutlet="itemTemplate; context: { item: item }"
			></ng-template>
		</ng-container>
	</ng-container>

	<button
		class="mt-[8px] ml-[9px]"
		*ngIf="hasHiddenItems"
		feather-icon-button
		type="button"
		[matMenuTriggerFor]="hiddenItemsMenu"
	>
		<feather-icon class="icon-sm" name="more-horizontal"></feather-icon>
	</button>
	<mat-menu #hiddenItemsMenu="matMenu" (click)="$event.stopPropagation()">
		<ng-container *ngFor="let item of items">
			<ng-container *ngIf="item.hide">
				<div  #toolbarItem
					class="flex flex-col body-2 w-full"
					*ngIf="item.visible == undefined || propertyOf(item.visible)"
					[ngSwitch]="item.type"
				>
					<ng-container *ngSwitchCase="'item'">
						<ng-container *ngIf="item.action">
							<button
								mat-menu-item
								type="button"
								class="menu-button body-2"
								[ngStyle]="{
									color: item.disabled
										? !item.disabled()
											? ''
											: 'var(--vex-toolbar-disabled-color)'
										: ''
								}"
								[disabled]="item.disabled && item.disabled()"
								(click)="item.action(item)"
							>
								<feather-icon
									class="icon-xs"
									[name]="icon(item)"
								></feather-icon>
								<span *ngIf="item.name || item.tooltip" class="pl-2">
									{{ name(item) ?? propertyOf(item.tooltip) }}</span
								>
							</button>
						</ng-container>
						<ng-container *ngIf="propertyOf(item.menu)">
							<button
								mat-menu-item
								type="button"
								class="menu-button body-2 custom-button"
								[ngStyle]="{
									color: item.disabled
										? !item.disabled()
											? ''
											: 'var(--vex-toolbar-disabled-color)'
										: ''
								}"
								[disabled]="item.disabled && item.disabled()"
								[matMenuTriggerFor]="
									item.disabled
										? !item.disabled()
											? templateMenu
											: null
										: templateMenu
								"
							>
								<feather-icon
									class="icon-xs"
									[name]="item.icon"
									[ngStyle]="{
										color: item.disabled
											? !item.disabled()
												? ''
												: 'var(--vex-toolbar-disabled-color)'
											: ''
									}"
								>
								</feather-icon>
								<span *ngIf="item.name || item.tooltip" class="pl-2">
									{{ name(item) ?? propertyOf(item.tooltip) }}</span
								>
							</button>
							<mat-menu #templateMenu="matMenu">
								<ng-container
									*ngTemplateOutlet="propertyOf(item.menu)"
								></ng-container>
							</mat-menu>
						</ng-container>
					</ng-container>
					<ng-container *ngSwitchCase="'dropdown'">
						<button
							mat-menu-item
							type="button"
							class="w-full flex flex-row items-center rounded justify-between custom-button"
							[disabled]="item.disabled && item.disabled()"
							[matMenuTriggerFor]="subMenu"
						>
							<span
								*ngIf="item.name || item.tooltip"
								class="flex flex-row items-center"
								[ngStyle]="{
									color: item.disabled
										? !item.disabled()
											? ''
											: 'var(--vex-toolbar-disabled-color)'
										: ''
								}"
							>
								<feather-icon
									class="icon-xs"
									[name]="item.icon"
								></feather-icon>
								<span class="pl-2">
									{{ name(item) ?? propertyOf(item.tooltip) }}</span
								>
							</span>
						</button>
						<mat-menu #subMenu="matMenu">
							<ng-container *ngFor="let child of item.children">
								<button
									mat-menu-item
									*ngIf="child.action"
									class="px-[2px] cursor-pointer"
									[disabled]="child.disabled && child.disabled()"
									(click)="child.action(child)"
									[style.color]="{
										'var(--vex-toolbar-disabled-color)':
											child.disabled && child.disabled()
									}"
								>
									<feather-icon
										*ngIf="child.icon"
										class="icon-xs mr-2"
										[name]="child.icon"
									></feather-icon>
									<span>{{
										name(child) ?? propertyOf(child.tooltip)
									}}</span>
								</button>
							</ng-container>
						</mat-menu>
					</ng-container>
					<ng-container *ngSwitchCase="'search'">
						<button
							(click)="openSearch()"
							mat-menu-item
							type="button"
							class="body-2"
						>
							<feather-icon color="primary" name="search"></feather-icon>
							<span class="pl-2"> {{ name(item) }}</span>
						</button>
					</ng-container>
					<ng-container *ngSwitchCase="'template'">
						<button
							mat-menu-item
							type="button"
							class="w-full rounded-flex-container justify-between"
							[disabled]="item.disabled && item.disabled()"
							[matMenuTriggerFor]="templateMenu"
						>
							<span
								*ngIf="item.name || item.tooltip"
								class="flex flex-row items-center"
								[ngStyle]="{
									color: item.disabled
										? !item.disabled()
											? ''
											: 'var(--vex-toolbar-disabled-color)'
										: ''
								}"
							>
								<feather-icon
									class="icon-xs"
									[name]="item.icon"
								></feather-icon>
								<span class="pl-2">
									{{ name(item) ?? propertyOf(item.tooltip) }}</span
								>
							</span>
						</button>
						<mat-menu
							#templateMenu="matMenu"
							yPosition="below"
							overlayPanelClass="max-w-[50rem]"
						>
							<ng-container
								*ngTemplateOutlet="item.template()"
							></ng-container>
						</mat-menu>
					</ng-container>
					<ng-container *ngSwitchCase="'menu'">
						<ng-container *ngIf="item.templateMenu()">
							<button
								mat-menu-item
								type="button"
								class="w-full rounded-flex-container justify-between"
								[disabled]="item.disabled && item.disabled()"
								[matMenuTriggerFor]="item.templateMenu()"
							>
								<span
									*ngIf="item.name || item.tooltip"
									class="flex flex-row items-center"
									[ngStyle]="{
										color: item.disabled
											? !item.disabled()
												? ''
												: 'var(--vex-toolbar-disabled-color)'
											: ''
									}"
								>
									<feather-icon
										class="icon-xs"
										[name]="item.icon"
									></feather-icon>
									<span class="pl-2">
										{{ name(item) ?? propertyOf(item.tooltip) }}</span
									>
								</span>
							</button>
						</ng-container>
					</ng-container>
					<ng-container *ngSwitchCase="'popover'">
						<!-- not tested yet TODO: usevex popover or other npm -->
						<button
							mat-menu-item
							class="rounded-flex-container"
							[disabled]="item.disabled && item.disabled()"
							feather-icon-button
							type="button"
							[ngClass]="{ 'bg-active': item.opened }"
							(click)="item.opened = !item.opened;"
						>
							<feather-icon
								class="icon-xs"
								[ngStyle]="{
									color: item.disabled
										? !item.disabled()
											? ''
											: 'var(--vex-toolbar-disabled-color)'
										: ''
								}"
								[name]="item.icon"
							></feather-icon>
							<span *ngIf="item.name || item.tooltip" class="pl-2">
								{{ name(item) ?? propertyOf(item.tooltip) }}</span
							>
						</button>
						<vex-popover
							*ngIf="item.opened"
							[renderMethod]="'template'"
							[content]="item.popover()"
						></vex-popover>
					</ng-container>
				</div>
			</ng-container>
		</ng-container>
	</mat-menu>
</div>

<ng-template #itemTemplate let-item="item">
	<div #toolbarItem
		class="items-container"
		*ngIf="item.visible == undefined || propertyOf(item.visible)"
		[ngSwitch]="item.type"
	>
		<ng-container *ngSwitchCase="'item'">
			<ng-container *ngIf="item.action">
				<button
					#menuItem
					id="button"
					feather-icon-button
					type="button"
					class="rounded-flex-container mx-[3px] px-[3px] h-9"
					[ngStyle]="{
						color: item.disabled
							? !item.disabled()
								? ''
								: 'var(--vex-toolbar-disabled-color)'
							: ''
					}"
					[disabled]="item.disabled && item.disabled()"
					[matTooltip]="propertyOf(item.tooltip)"
					matTooltipClass="full-width-tooltip"
					(click)="$event.stopPropagation(); item.action(item)"
					(resized)="item.size = $event.newRect"
				>
					<feather-icon
						class="icon-xs"
						[name]="icon(item)"
					></feather-icon>
					<span *ngIf="item.name" class="pl-1"> {{ name(item) }}</span>
				</button>
			</ng-container>
			<ng-container *ngIf="propertyOf(item.menu)">
				<button
					#menuItem
					id="button"
					feather-icon-button
					type="button"
					class="block rounded-flex-container mx-[3px] px-[3px] h-9"
					[ngStyle]="{
						color: item.disabled
							? !item.disabled()
								? ''
								: 'var(--vex-toolbar-disabled-color)'
							: ''
					}"
					[matTooltip]="propertyOf(item.tooltip)"
					matTooltipClass="full-width-tooltip"
					[disabled]="item.disabled && item.disabled()"
					(resized)="item.size = $event.newRect"
					(click)="$event.stopPropagation()"
					[matMenuTriggerFor]="
						item.disabled
							? !item.disabled()
								? templateMenu
								: null
							: templateMenu
					"
				>
					<feather-icon
						class="icon-xs"
						[name]="item.icon"
						[ngStyle]="{
							color: item.disabled
								? !item.disabled()
									? ''
									: 'var(--vex-toolbar-disabled-color)'
								: ''
						}"
					>
					</feather-icon>
					<span *ngIf="item.name" class="pl-1"> {{ name(item) }}</span>
				</button>
				<mat-menu #templateMenu="matMenu">
					<ng-container
						*ngTemplateOutlet="propertyOf(item.menu)"
					></ng-container>
				</mat-menu>
			</ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="'dropdown'">
			<button
				#menuItem
				feather-icon-button
				id="button"
				type="button"
				class="rounded-flex-container cursor-pointer mx-[3px] h-9 px-[3px] custom-button"
				[disabled]="item.disabled && item.disabled()"
				[matTooltip]="propertyOf(item.tooltip)"
				matTooltipClass="full-width-tooltip"
				[matMenuTriggerFor]="
					item.disabled ? (!item.disabled() ? subMenu : null) : subMenu
				"
				(click)="$event.stopPropagation()"
				(resized)="item.size = $event.newRect"
			>
				<feather-icon
					class="icon-xs"
					[ngStyle]="{
						color: item.disabled
							? !item.disabled()
								? ''
								: 'var(--vex-toolbar-disabled-color)'
							: ''
					}"
					[name]="item.icon"
				>
				</feather-icon>
				<span
					*ngIf="item.name"
					class="pl-1"
					[ngStyle]="{
						color: item.disabled
							? !item.disabled()
								? ''
								: 'var(--vex-toolbar-disabled-color)'
							: ''
					}"
				>
					{{ name(item) }}</span
				>
			</button>
			<mat-menu #subMenu="matMenu">
				<ng-container *ngFor="let child of item.children">
					<button
						*ngIf="child.action && propertyOf(child.visible)"
						[disabled]="child.disabled && child.disabled()"
						(click)="child.action(child)"
						[style.color]="{
							'var(--vex-toolbar-disabled-color)':
								child.disabled && child.disabled()
						}"
						mat-menu-item
					>
						<feather-icon
							*ngIf="child.icon"
							class="icon-xs mr-2"
							[name]="child.icon"
						></feather-icon>
						<span>{{ propertyOf(child.tooltip) }}</span>
					</button>
				</ng-container>
			</mat-menu>
		</ng-container>
		<ng-container *ngSwitchCase="'search'">
			<button
				(click)="openSearch()"
				feather-icon-button
				type="button"
				class="body-2"
			>
				<feather-icon color="primary" name="search"></feather-icon>
			</button>
		</ng-container>
		<ng-container *ngSwitchCase="'template'">
			<button
				#menuItem
				feather-icon-button
				id="button"
				type="button"
				class="rounded-flex-container mx-[3px] h-9 px-[3px]"
				[disabled]="item.disabled && item.disabled()"
				[matTooltip]="propertyOf(item.tooltip)"
				matTooltipClass="full-width-tooltip"
				[ngStyle]="{
					color: item.disabled
						? !item.disabled()
							? ''
							: 'var(--vex-toolbar-disabled-color)'
						: ''
				}"
				[matMenuTriggerFor]="templateMenu"
				(click)="$event.stopPropagation()"
				(resized)="item.size = $event.newRect"
			>
				<feather-icon
					class="icon-xs"
					[name]="item.icon"
				></feather-icon>
				<span *ngIf="item.name" class="pl-1"> {{ name(item) }}</span>
			</button>
			<mat-menu
				#templateMenu="matMenu"
				yPosition="below"
				overlayPanelClass="max-w-[50rem]"
			>
				<ng-container *ngTemplateOutlet="item.template()"></ng-container>
			</mat-menu>
		</ng-container>
		<ng-container *ngSwitchCase="'menu'">
			<ng-container *ngIf="item.templateMenu()">
				<button
					feather-icon-button
					id="button"
					type="button"
					class="rounded-flex-container mx-[3px] h-9 px-[3px]"
					[matTooltip]="propertyOf(item.tooltip)"
					matTooltipClass="full-width-tooltip"
					[ngStyle]="{
						color: item.disabled
							? !item.disabled()
								? ''
								: 'var(--vex-toolbar-disabled-color)'
							: ''
					}"
					[matMenuTriggerFor]="item.templateMenu()"
					(click)="$event.stopPropagation()"
					(resized)="item.size = $event.newRect"
				>
					<feather-icon
						class="icon-xs"
						[name]="item.icon"
					></feather-icon>
					<span *ngIf="item.name" class="pl-1"> {{ name(item) }}</span>
				</button>
			</ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="'popover'">
			<button
				#profileMenuOriginRef
				id="button"
				class="rounded-flex-container h-9 px-[3px] mx-[3px]"
				(click)="openPopover(profileMenuOriginRef,item)"
				[disabled]="item.disabled && item.disabled()"
				[matTooltip]="propertyOf(item.tooltip)"
				matTooltipClass="full-width-tooltip"
				[ngClass]="{ 'bg-active': item.opened || propertyOf(item.active) }"
				type="button"
			>
				<feather-icon
					class="icon-xs"
					[ngStyle]="{
						color: item.disabled
							? !item.disabled()
								? ''
								: 'var(--vex-toolbar-disabled-color)'
							: ''
					}"
					[name]="item.icon"
				></feather-icon>
				<span *ngIf="item.name" class="pl-1"> {{ name(item) }}</span>
			</button>
		</ng-container>
	</div>
</ng-template>
